import $ from 'jquery';
$(document).ready(() => {

    /*if ($(window).width() >= 1280) {
        $(window).scroll(testScroll);
        let viewed = false;

        function isScrolledIntoView(elem) {
            let docViewTop = $(window).scrollTop();
            let docViewBottom = docViewTop + $(window).height();

            let elemTop = $(elem).offset().top;
            let elemBottom = elemTop + $(elem).height();

            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

        function testScroll() {
            if (isScrolledIntoView($(".numbers")) && !viewed) {
                viewed = true;
                $('.value').each(function () {
                    $(this).prop('Counter',0).animate({
                        Counter: $(this).text()
                    }, {
                        duration: 2000,
                        easing: 'swing',
                        step: function (now) {
                            $(this).text(Math.ceil(now));
                        }
                    });
                });
            }
        }
    }*/
    var fx = function fx() {
        $(".chiffre").each(function (i, el) {
            var data = parseInt(this.dataset.n, 10);
            var props = {
                "from": {
                    "count": 0
                },
                "to": {
                    "count": data
                }
            };
            $(props.from).animate(props.to, {
                duration: 1000 * 1,
                step: function (now, fx) {
                    $(el).text(Math.ceil(now));
                },
                complete:function() {
                    if (el.dataset.sym !== undefined) {
                        el.textContent = el.textContent.concat(el.dataset.sym)
                    }
                }
            });
        });
    };

    var scrolled = false;
    var reset = function reset() {
        if (!scrolled) {
            //console.log($(this).scrollTop())
            if ($(this).scrollTop() > 90) {
                scrolled= true;
                console.log(this);
                fx()
            }
        }
    };

    $(window).on("scroll", reset);


    $(function() {
        let $sliderTesti = $('.testimonial-slider');
        $sliderTesti.slick({
            autoplay: true,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            prevArrow: $('.previous-t'),
            nextArrow: $('.next-t'),
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2.2,
                        slidesToScroll: 1.1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.8,
                        slidesToScroll: 1.8,
                        infinite: true,
                        dots: false
                    }
                }
            ]
        });
    });
})

